import _extends from "@babel/runtime/helpers/esm/extends";
import { createRegisteredContext } from 'react-singleton-context';
import { createStore } from 'zustand';
import { isNil, noop, omitBy } from 'lodash';
var DEFAULT_PROPS = {
  routingMap: {},
  navigate: function navigate() {
    return {};
  },
  navigateBack: noop,
  switchAccount: noop
};
export function createModulesStore(initProps) {
  return createStore()(function () {
    return _extends({}, DEFAULT_PROPS, omitBy(initProps, isNil));
  });
}
var ModulesContext = createRegisteredContext('ModulesContext', null);
export default ModulesContext;